/**
 * Load a css resource into the document head
 * @param document the document
 * @param src resource src
 */
function loadCssResource(document, src: string): void {
    const cssLinkPreloader = document.createElement('link');
    cssLinkPreloader.rel = 'preload';
    cssLinkPreloader.as = 'style';
    cssLinkPreloader.href = src;
    document.head.appendChild(cssLinkPreloader);

    const cssLink = document.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.href = src;
    document.head.appendChild(cssLink);
}

export default loadCssResource;
